import { ref } from "vue";

export const accessAlertState = ref({
  show: false,
  message: "",
  onConfirm: null,
});

export const showAccessDeniedAlert = (message, onConfirm) => {
  accessAlertState.value = {
    show: true,
    message: message || "Anda tidak memiliki akses ke halaman ini.",
    onConfirm: onConfirm || null,
  };
};

export const closeAccessDeniedAlert = () => {
  const confirmCb = accessAlertState.value.onConfirm;
  accessAlertState.value = {
    show: false,
    message: "",
    onConfirm: null,
  };
  if (typeof confirmCb === "function") {
    confirmCb();
  }
};
